export const dateConfig = {
  dateString: 'YYYY-MM-DD',
  timeString: 'HH:mm:ss',
  dateTimeString: 'YYYY-MM-DDTHH:mm:ss',
  dateFormat: 'DD/MM/YYYY',
  timeFormat: 'HH:mm A',
};

export const configAppInstance = {
  client: 'fastcover',
};



// WEBPACK FOOTER //
// ./app/configureApp.js